/**
 * Utility functions for audio processing
 */

/**
 * Converts a Uint8Array to base64 string using chunked approach to avoid stack overflow
 * @param uint8Array - The Uint8Array to convert
 * @returns Base64 encoded string
 */
export const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
  const chunkSize = 8192; // Process in chunks to avoid stack overflow
  let result = '';
  
  for (let i = 0; i < uint8Array.length; i += chunkSize) {
    const chunk = uint8Array.slice(i, i + chunkSize);
    result += String.fromCharCode.apply(null, Array.from(chunk));
  }
  
  return btoa(result);
};

/**
 * Converts an audio blob to base64 string
 * @param audioBlob - The audio blob to convert
 * @returns Promise that resolves to base64 encoded string
 */
export const audioBlobToBase64 = async (audioBlob: Blob): Promise<string> => {
  const arrayBuffer = await audioBlob.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);
  return uint8ArrayToBase64(uint8Array);
};
